import React from 'react';
import { labelOfLang } from './langs';
import { track } from './analytics';

// Un "audio" d'une île (narration ou vitrine), avec une source par langue.
// Choisit la meilleure source : langue choisie > version unique ("all") >
// français > première disponible. Affiche une note si la langue jouée diffère.
const AudioBlock = ({ audio, lang, listenLabel, ileId, showLabel = true }) => {
  const { sources, label } = audio;
  const order = [lang, 'all', 'fr', ...Object.keys(sources)];
  const usedLang = order.find((c) => sources[c]);
  if (!usedLang) return null;

  const src = sources[usedLang];
  const isFallback = usedLang !== lang && usedLang !== 'all';

  const handlePlay = () => {
    track('audioguide_audio_play', { ile_id: ileId, audio: label, langue: usedLang });
  };

  return (
    <section className="visite-audio-block">
      {(showLabel || isFallback) && (
        <p className="visite-audio-label">
          {showLabel && label}
          {isFallback && (
            <span className="visite-audio-note">
              {showLabel ? ' · ' : ''}
              {labelOfLang(usedLang)}
            </span>
          )}
        </p>
      )}
      <audio
        key={src}
        controls
        preload="none"
        className="visite-audio-player"
        aria-label={`${listenLabel} — ${label}`}
        onPlay={handlePlay}
      >
        <source src={src} type="audio/mpeg" />
        Votre navigateur ne permet pas la lecture audio.
      </audio>
    </section>
  );
};

export default AudioBlock;
